import React from 'react';
const rows = [['Hours every week building sessions from scratch', 'Two minutes before club and you’re ready'], ['Random lessons with no real progression', '71 sessions, sequenced across the season'], ['Kids waiting for a board with nothing to do', 'Rotations built for 30 kids and 8 sets'], ['“What are we doing today?” panic at the door', 'Print today’s worksheet and teach it'], ['Getting caught out on a rule in front of the kids', 'The answer to “is that legal?” on one page']];
export function CostOfInaction() {
  return <section className="w-full bg-navy-deep" data-id="element-65" data-mp="38vsg6dwlpj0x">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-66" data-mp="3dntndlewwjk3">
        <h2 className="text-center font-display text-white text-[28px] sm:text-4xl" data-id="element-67" data-mp="3dqer6fyrt9kh">
          What another improvised season costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-navy-line" data-id="element-68" data-mp="3nnasa0mcatf0">
          <div className="grid grid-cols-2 text-center" data-id="element-69" data-mp="3sl2ubngp7vwx">
            <div className="border-r border-navy-line bg-crimson px-3 py-3 font-display text-base text-white sm:text-lg" data-id="element-70" data-mp="3slui4c420pcn">
              So no
            </div>
            <div className="bg-green px-3 py-3 font-display text-base text-white sm:text-lg" data-id="element-71" data-mp="39gbsgf2w4s2a">
              So yes
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-navy-line text-[12.5px] sm:text-sm" data-id="element-72" data-mp="30hgm92zujhyz">
              <div className="border-r border-navy-line px-3.5 py-3.5 text-white/60 line-through decoration-crimson/60" data-id="element-73" data-mp="13o11fh6uigy">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-medium text-white" data-id="element-74" data-mp="3ng32k4qadob0">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}